import type { ReleaseGuideStep } from '@/types/release.types';

interface ReleaseStepGuideProps {
  title: string;
  steps: ReleaseGuideStep[];
  isTerminalOnline?: boolean;
}

export function ReleaseStepGuide({ title, steps, isTerminalOnline }: ReleaseStepGuideProps) {
  return (
    <section className="bg-surface-lowest rounded-4 shadow-kiosk-sm p-3 p-lg-4 mt-3">
      <div className="d-flex align-items-center justify-content-between mb-3">
        <h3 className="text-label-lg text-on-surface mb-0">{title}</h3>
        {isTerminalOnline !== undefined && (
          <span
            className={`badge fw-medium text-label-sm ${
              isTerminalOnline ? 'bg-surface-high text-success' : 'bg-surface-high text-danger'
            }`}
          >
            {isTerminalOnline ? 'Online' : 'Offline'}
          </span>
        )}
      </div>

      <div className="d-flex flex-column gap-2">
        {steps.map((step, index) => (
          <div key={step.id} className="bg-surface-low rounded-3 p-3 d-flex align-items-start gap-3">
            <span
              className="rounded-circle bg-primary text-white d-flex align-items-center justify-content-center flex-shrink-0 text-label-sm fw-bold"
              style={{ width: 28, height: 28 }}
            >
              {index + 1}
            </span>
            <div className="min-w-0">
              <span className="text-label-md text-on-surface d-block">{step.title}</span>
              <span className="text-body-sm text-on-surface-variant">{step.description}</span>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}
